import {
  Box,
  getThemeColor,
  getThemeSpacing,
  Text,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const MapButton = styled(Box)`
  cursor: pointer;
  backdrop-filter: blur(4px);
  height: 45px;
  width: 45px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => `${getThemeColor('white', theme)}AA`};
  padding: ${({ theme }) => getThemeSpacing(1, theme)};
  border-radius: ${({ theme }) => theme.border_radius.input};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  border: ${({ theme }) => `1px solid ${getThemeColor('grey_4', theme)}`};
`

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
`

export const Minimap = styled(Box)`
  cursor: grab;
`

export const TopPanel = styled(Box)`
  padding: 4px 8px;
  height: 45px;
  backdrop-filter: blur(4px);
  background-color: ${({ theme }) => `${getThemeColor('white', theme)}AA`};
  border-radius: ${({ theme }) => theme.border_radius.input};
  border: ${({ theme }) => `1px solid ${getThemeColor('grey_4', theme)}`};
  display: flex;
  align-items: center;
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  gap: 2px;

  p {
    font-size: 12px;
  }
`

export const ButtonText = styled(Text)`
  p {
    font-size: 12px;
    font-weight: 400;
  }
`
